import type { Parameter, Schema } from '@/lib/openapi/types';

interface Props {
    title: string;
    params: Parameter[];
}

export default function ParamTable({ title, params }: Props) {
    if (!params || params.length === 0) return null;
    return (
        <div className="mb-6">
            <h3 className="text-sm font-semibold text-ink mb-3">{title}</h3>
            <div className="space-y-1">
                {params.map((p) => (
                    <div key={p.name} className="flex items-start gap-3 py-2.5" style={{ borderBottom: '1px solid var(--border)' }}>
                        <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-0.5">
                                <code className="text-xs font-semibold text-ink font-mono">{p.name}</code>
                                <span className="text-xxs text-ghost">{typeLabel(p.schema)}</span>
                                {p.required && <span className="text-xxs font-semibold text-red-400">wajib</span>}
                            </div>
                            {p.description && (
                                <p className="text-xs text-muted leading-relaxed">{p.description}</p>
                            )}
                            {p.schema?.enum && (
                                <p className="text-xxs text-ghost mt-1 font-mono">
                                    Pilihan: {p.schema.enum.map((v) => `"${v}"`).join(', ')}
                                </p>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

function typeLabel(s: Schema | undefined): string {
    if (!s) return '';
    if (s.format) return `${s.type}<${s.format}>`;
    if (s.type === 'array' && s.items) return `${s.items.type || 'any'}[]`;
    return s.type || '';
}
